export default __webpack_public_path__ + "static/media/photo-icon.00986a09.png";